import React from "react";

import { templates } from "@reactivated";

import { OutOfContextBundleCollection } from "../apps/product-detail/PDPBundles";

export const Template = (
    _props: templates.PDPBundlesTemplate,
): React.JSX.Element => {
    return (
        <div className="pdp-section pdp-bundles l-capped-width">
            <div className="pdp-section__body pdp-bundles__content">
                <OutOfContextBundleCollection />
            </div>
        </div>
    );
};
